import { BillingUser } from "src/graphql/types/__generated__/type";

export function isBillingUser(obj?: Record<string, unknown>): obj is BillingUser {
  return obj?.__typename === "BillingUser";
}
